export default __webpack_public_path__ + "static/media/Exam_3_2.42782339.png";